import { useEffect, useState } from 'react';
import { fmtLeft, takeBackLeft } from '../lib/takeBack.js';

/**
 * ehr#682 (PROGRESS-NOTE V141 V83.4): "Take it back · 4:59" with a live countdown. It goes away
 * (onExpired) when the time is up; the API checks the window and the author again on the click.
 */
export function TakeBackButton({
  until,
  busy,
  onTakeBack,
  onExpired,
}: {
  until: string;
  busy: boolean;
  onTakeBack: () => void;
  onExpired: () => void;
}) {
  const [now, setNow] = useState(() => Date.now());
  const left = takeBackLeft(until, now);
  useEffect(() => {
    if (left <= 0) {
      onExpired();
      return;
    }
    const t = window.setTimeout(() => setNow(Date.now()), Math.min(1000, left));
    return () => window.clearTimeout(t);
  });
  if (left <= 0) return null;
  return (
    <button type="button" className="btn pn-takeback" onClick={onTakeBack} disabled={busy}>
      Take it back &middot; <span className="pn-takeback-cd">{fmtLeft(left)}</span>
    </button>
  );
}
